import React from 'react';
import style from './tab-selector.module.scss';

type Tab = 'onEnter' | 'onReceive';

type Props = {
	selected: Tab;
	onTabSelect: (tab: Tab) => void;
};

export function TabSelector(props: Props) {
	const { selected, onTabSelect } = props;
	return (
		<div className={style.tabSelector}>
			{tabs.map((tab) => {
				return (
					<button
						key={tab.value}
						data-selected={selected === tab.value}
						onClick={() => onTabSelect(tab.value)}
					>
						{tab.label}
					</button>
				);
			})}
		</div>
	);
}

const tabs = [
	{ value: 'onEnter', label: 'On Enter' },
	{ value: 'onReceive', label: 'On Receive' },
] as const;
